import {Component, OnInit, Input, ElementRef} from '@angular/core';

@Component({
	selector: 'indiapicture-product-list',
	templateUrl: './product-list.component.html',
	styleUrls: ['./product-list.component.scss']
})

export class ProductListComponent implements OnInit {

	@Input() type: string;
	@Input() searchText: string;
	@Input() products = [];
	@Input() previewArr = [];
	@Input() loaded = false;
	@Input() containerClass = 'container';
	// @Input() cols = "col-6 col-md-4 col-lg-4 col-xl-3";
	@Input() cols = "product-item";

	constructor() {
	}

	ngOnInit(): void {
	}

	hover(index) {
		// this.isHovering = this.products[index].id + '';
		this.products[index].isHover = true;
	}

	play(video: ElementRef) {
		video.nativeElement.play();
	}
}
